<template>
  <form-item-wrapper
    :designer="designer"
    :field="field"
    :rules="rules"
    :design-state="designState"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex"
    :sub-form-col-index="subFormColIndex"
    :sub-form-row-id="subFormRowId"
  >
    <simditor
      ref="simditor"
      v-model="fieldModel"
      :options="options"
      :id.sync="id"
      @change="change"
      :placeholder="field.options.placeholder"
      @focus="handleRichEditorFocusEvent"
      @blur="handleRichEditorBlurEvent"
      :disabled="field.options.disabled || isReadMode"
      style="width: 100%"
    >
    </simditor>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "./form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n, { translate } from "@/utils/i18n";
import { deepClone } from "@/utils/util";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";

import Simditor from "@/components/simditor";
export default {
  name: "rich-editor-widget",
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  components: {
    FormItemWrapper,
    Simditor,
  },
  inject: ["refList", "globalOptionData", "globalModel"],
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: null,
      rules: [],
      valueChangedFlag: false, //vue2-editor数据值是否改变标志
      content: "",
      //工具栏配置项
      options: {
        placeHolder: "this is placeHolder",
        toolbarFloat: false,
        toolbar: [
          "bold",
          "italic",
          "title",
          "link",
          "image",
          "ol",
          "ul",
          "indent",
          "outdent",
          "alignment",
          "underline",
          "strikethrough",
          "fontScale",
          "color",
          // "|",
          "blockquote",
          "code",
          "table",
          // "|",
          // "hr",
          // "|",
        ],
        pasteImage: true, //占位符(图片)
        upload: {
          url: `http://...`, //文件上传的接口地址
          params: null, //键值对,指定文件上传接口的额外参数,上传的时候随文件一起提交
          fileKey: "file", //服务器端获取文件数据的参数名
          connectionCount: 3, //同时上传多少张图片
          leaveConfirm: "正在上传文件",
        },
      },
      id: "",
    };
  },
  beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },

  created() {
    this.id = this.field.options.name;
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initFieldModel();
    this.initEventHandler();
    this.buildFieldRules();

    this.handleOnCreated();
  },

  mounted() {
    this.handleOnMounted();
  },

  beforeDestroy() {
    this.unregisterFromRefList();
  },

  methods: {
    setEditorValue(val){
      this.$refs.simditor.setVal(val)
    },
    change(val) {
      this.fieldModel = val;
      this.syncUpdateFormModel(this.fieldModel);
    },
    // handleRichEditorChangeEvent() {
    //   this.valueChangedFlag = true;
    //   this.syncUpdateFormModel(this.fieldModel);
    //   console.log("change");
    // },

    handleRichEditorFocusEvent() {
      this.oldFieldValue = deepClone(this.fieldModel);
    },

    handleRichEditorBlurEvent(n) {
      if (this.valueChangedFlag) {
        this.valueChangedFlag = false;
      }
      this.fieldModel = n;
      this.syncUpdateFormModel(this.fieldModel);
      this.emitFieldDataChange(this.fieldModel, this.oldFieldValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/global.scss"; //* form-item-wrapper已引入，还需要重复引入吗？ *//

::v-deep .edui-editor,
.edui-default {
  width: auto !important;
}
</style>
